export const getStatusFromCounts = ({
  uncalledCount,
  totalCount,
}: {
  uncalledCount: number;
  totalCount: number;
}) => {
  return uncalledCount === 0
    ? 'Complete'
    : uncalledCount === totalCount
      ? 'Not started'
      : 'In progress';
};
